import { ActionButton } from '../ActionButton/ActionButton';
export var CommandButton = ActionButton;
//# sourceMappingURL=CommandButton.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/Button/CommandButton/CommandButton.js
// module id = 658
// module chunks = 0